export const ANALYTICS_IDENTITY_EVENT = 'sokrates:analytics-identity';
let notificationPending = false;

/** Notify after storage mutations without coupling auth/storage to Angular routing. */
export function notifyAnalyticsIdentityChanged(): void {
  if (typeof window === 'undefined' || notificationPending) {
    return;
  }
  notificationPending = true;
  Promise.resolve().then(() => {
    notificationPending = false;
    window.dispatchEvent(new Event(ANALYTICS_IDENTITY_EVENT));
  });
}
